export const NOTE_CREATE_REQUEST = 'NOTE_CREATE_REQUEST';
export const NOTE_CREATE = 'NOTE_CREATE';
export const NOTE_FETCH_REQUEST = 'NOTE_FETCH_REQUEST';
export const NOTE_FETCH = 'NOTE_FETCH';
export const NOTE_UPDATE_REQUEST = 'NOTE_UPDATE_REQUEST';
export const NOTE_UPDATE = 'NOTE_UPDATE';
export const NOTE_DELETE_REQUEST = 'NOTE_DELETE_REQUEST';
export const NOTE_DELETE = 'NOTE_DELETE';
export const NOTE_CLEAR = 'NOTE_CLEAR';
